export default __webpack_public_path__ + "static/media/arrow-large.849745e8.svg";